import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import SparklesIcon from 'icons/Sparkles.icon';
import { Button } from 'ncoded-component-library';
import GuideTourContext from 'providers/GuideTour/GuideTour.context';

import './WorkflowHeader.styles.scss';

type WorkflowHeaderProps = {
  className?: string;
  title: string;
};

const WorkflowHeader: React.FC<WorkflowHeaderProps> = (props) => {
  const { className, title } = props;

  const { onShowGuide } = useContext(GuideTourContext);

  const classes = classNames('workflow-header', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <p>{title}</p>

      <Button variant="outline" icon={SparklesIcon} onClick={onShowGuide}>
        {t('startTour')}
      </Button>
    </div>
  );
};

export default WorkflowHeader;
